import React from "react";
import { Card, Descriptions, Tag, Typography, Avatar, Button, Row, Col, Space, Divider } from "antd";
import { UserOutlined, MailOutlined, SafetyCertificateOutlined, LogoutOutlined, EditOutlined } from "@ant-design/icons";
import { useAuth } from "../../auth/model/AuthContext";

const { Title, Text } = Typography;

export const ProfileView: React.FC = () => {
  const { user, logout } = useAuth();

  if (!user) return null;

  return (
    <div style={{ maxWidth: 800, margin: "0 auto" }}>
      {/* Profile Header Card */}
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        }}
        bodyStyle={{ padding: 24 }}
      >
        <Row align="middle" gutter={[16, 16]}>
          <Col xs={24} sm={6} style={{ textAlign: "center" }}>
            <Avatar size={72} icon={<UserOutlined />} style={{ backgroundColor: "#1677ff" }} />
          </Col>
          <Col xs={24} sm={18}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8 }}>
              <div>
                <Title level={3} style={{ margin: 0 }}>
                  {user.display_name || "ユーザー"}
                </Title>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  <MailOutlined style={{ marginRight: 6 }} />
                  {user.email}
                </Text>
              </div>
              <Tag color={user.is_active ? "success" : "default"} icon={<SafetyCertificateOutlined />}>
                {user.is_active ? "アカウント有効" : "無効"}
              </Tag>
            </div>
          </Col>
        </Row>
      </Card>

      {/* Detail Account Info */}
      <Card
        title="アカウント情報"
        style={{ borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}
        extra={
          <Button type="link" icon={<EditOutlined />}>
            編集
          </Button>
        }
      >
        <Descriptions bordered column={{ xs: 1, sm: 1, md: 2 }} size="small">
          <Descriptions.Item label="お名前">
            {user.display_name || "未設定"}
          </Descriptions.Item>
          <Descriptions.Item label="メールアドレス">
            {user.email}
          </Descriptions.Item>
          <Descriptions.Item label="ユーザー種別">
            <Tag color="blue">{user?.roles}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="ユーザーID">
            <Text code>{user.user_id}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="所属店舗 / 会社名" span={2}>
            メイセイ店舗 A
          </Descriptions.Item>
        </Descriptions>

        <Divider />

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button danger icon={<LogoutOutlined />} onClick={logout}>
            ログアウト
          </Button>
        </div>
      </Card>
    </div>
  );
};
